import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/logo/logo_simple.png'


const _hoisted_1 = {
  ref: "root",
  class: "news topPage"
}
const _hoisted_2 = { class: "slider-outer" }
const _hoisted_3 = { class: "slider-inner" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "news-content" }
const _hoisted_6 = { class: "news-content-date" }
const _hoisted_7 = { class: "news-content-title" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "price-button" }
const _hoisted_10 = { class: "button-wrap" }
const _hoisted_11 = { class: "button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.slides, (slide, idx) => {
          return (_openBlock(), _createElementBlock("img", {
            key: idx,
            class: _normalizeClass([_ctx.state.current_slide == idx ? 'active' : '', "slide-img"]),
            src: _ctx.state.slides[idx].img
          }, null, 10, _hoisted_4))
        }), 128))
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "over-ray" }, [
        _createElementVNode("div", { class: "top-inner" }, [
          _createElementVNode("div", { class: "top-items-title" }, [
            _createElementVNode("h2", null, "News"),
            _createElementVNode("p", null, "お知らせ")
          ])
        ])
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.products[_ctx.$route.query.id].date), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.products[_ctx.$route.query.id].title), 1),
      _createElementVNode("div", {
        class: "news-content-text",
        innerHTML: _ctx.products[_ctx.$route.query.id].text
      }, null, 8, _hoisted_8),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: "/#news",
              onClick: _ctx.onTapReturnButton
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "icon-arrow-left" }, null, -1),
                _createTextVNode(" 戻る ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "news-bg" }, [
        _createElementVNode("img", { src: _imports_0 })
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "news-bg2" }, [
        _createTextVNode(" Make The Body"),
        _createElementVNode("br"),
        _createTextVNode(" You Dream About ")
      ], -1))
    ])
  ], 512))
}